import { Dispatch, FC, SetStateAction } from "react";
import { ShareLink } from "../../../generated/graphql";
import { ShareLinkRow } from "./ShareLinkRow";

interface ShareLinksListProps {
  links: Partial<ShareLink>[];
  canManage: boolean;
  onOpenModal: (id: string) => void;
  setNotifications: Dispatch<
    SetStateAction<{ error: boolean; success: boolean; message: string }>
  >;
}

export const ShareLinksList: FC<ShareLinksListProps> = ({
  links,
  canManage,
  onOpenModal,
  setNotifications,
}) => (
  <>
    {links.map((link) => (
      <ShareLinkRow
        key={link.id}
        link={link}
        canManage={canManage}
        onOpenModal={onOpenModal}
        setNotifications={setNotifications}
      />
    ))}
  </>
);
